import buildIntegrationConnection from 'app/shared/translation/integrations/buildIntegrationConnection';
import buildIntegrationConsent from 'app/shared/translation/integrations/translatePipelineIntegration/buildIntegrationConsent';

/**
 * Builds the connection-only integration object for /v1.1/test/deliver_event
 * from CURRENT playbook-editor state (possibly unsaved), instead of a staged
 * revision attached to a pipeline (see translatePipelineIntegration for that
 * flow). The deliver endpoint takes an already-transformed event, so this
 * intentionally has no transformStages and no revision reference.
 */
export default function buildEditorIntegration({
  connectionJson,
  vars = null,
  pipelineVars = null,
  pipelineVariables = [],
  starterkitId,
  integrationId,
  pipelineIntegrationConsent = null,
}) {
  const { connectionType, connection } = buildIntegrationConnection({
    connectionJson,
    vars,
    pipelineVars,
    pipelineVariables,
    starterkitId,
  });

  const integrationJson = {
    ...(connectionType === 'endpointSchema' && { connection: { params: [] } }),
    [connectionType]: connection,
    integrationName: starterkitId,
    id: integrationId,
    disabled: false,
  };

  const consent = buildIntegrationConsent(pipelineIntegrationConsent);
  if (consent) {
    integrationJson.consent = consent;
  }

  return integrationJson;
}
